/** @format */

export const getPageTemplate = (pathname: string): string => {
    const path = pathname.replace(/^\/s\//, '/');

    return path.split('/').find(Boolean) ?? 'home';
};

export const trackPageViewForRiskified = (pathname: string) => {
    const pageTemplate = getPageTemplate(pathname);

    window.RISKX?.go(pageTemplate);
};
